import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import WorkflowList from './pages/WorkflowList';
import WorkflowDetail from './pages/WorkflowDetail';
import CreateWorkflow from './pages/CreateWorkflow';
import ObservabilityPage from './pages/ObservabilityPage';
import ResourcesPage from './pages/ResourcesPage';
import TemplateLibrary from './components/templates/TemplateLibrary';
import { awsConfig } from './aws-config';
import './index.css';

// Configure Amplify with your Cognito settings
Amplify.configure(awsConfig);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// Customize the authentication form
const formFields = {
  signUp: {
    given_name: {
      label: 'First Name',
      placeholder: 'Enter your first name',
      isRequired: true,
      order: 1
    },
    family_name: {
      label: 'Last Name',
      placeholder: 'Enter your last name',
      isRequired: true,
      order: 2
    },
    email: {
      label: 'Email',
      placeholder: 'Enter your email address',
      isRequired: true,
      order: 3
    },
    password: {
      label: 'Password',
      placeholder: 'Enter your password',
      isRequired: true,
      order: 4
    },
    confirm_password: {
      label: 'Confirm Password',
      placeholder: 'Confirm your password',
      isRequired: true,
      order: 5
    }
  }
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Authenticator 
        formFields={formFields}
        components={{
          Header() {
            return (
              <div style={{ textAlign: 'center', padding: '2rem 0' }}>
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📊</div>
                <h1 style={{ color: '#1976d2', fontSize: '2rem', margin: 0 }}>
                  Workflow Manager
                </h1>
                <p style={{ color: '#666', margin: '0.5rem 0 0 0' }}>
                  Durable workflow orchestration platform
                </p>
              </div>
            );
          },
          Footer() {
            return (
              <div style={{ textAlign: 'center', padding: '1rem 0', fontSize: '0.875rem', color: '#666' }}>
                <p>🔄 Durable Workflows • 🚀 Serverless • 📊 Real-time Monitoring</p>
              </div>
            );
          }
        }}
      >
        {({ signOut, user }) => (
          <Router>
            <Layout user={user} signOut={signOut}>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/workflows" element={<WorkflowList />} />
                <Route path="/workflows/:executionArn" element={<WorkflowDetail />} />
                <Route path="/create" element={<CreateWorkflow />} />
                <Route path="/templates" element={<TemplateLibrary />} />
                <Route path="/observability" element={<ObservabilityPage />} />
                <Route path="/resources" element={<ResourcesPage />} />
              </Routes>
            </Layout>
          </Router>
        )}
      </Authenticator>
    </QueryClientProvider>
  );
}

export default App;
